/**
 * @fileOverview Handles the boiler plate of figuring out when the user
 * releases their mouse or touch over a container.
 */

import React, { Component } from 'react'

class DropZone extends Component {
  componentDidMount = () => {
    document.body.addEventListener('mouseup', this.onMouseUp)
    document.body.addEventListener('touchup', this.onMouseUp)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mouseup', this.onMouseUp)
    document.body.removeEventListener('touchup', this.onMouseUp)
  }

  onMouseUp = e => {
    const { onDrop } = this.props
    if (!onDrop) return
    // Check that the target element the mouse was released on was within
    // or is this container

    var node = e.target
    while (true) {
      if (node === document.body) return
      if (node === this.container_) break
      node = node.parentNode
    }

    onDrop()
  }

  render = () => {
    const { children, ...otherProps } = this.props
    return (
      <div {...otherProps} ref={el => (this.container_ = el)}>
        {children}
      </div>
    )
  }
}

export default DropZone
